export default class MailUtils {
    static getRawDomain(domain) {
        return domain.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0].toLowerCase();
    }
}